module.exports = __webpack_public_path__ + "static/media/bluntparrot.fbab321b.gif";